import React, { useState } from 'react'
import styles from "../../pages/OnBoarding/UserOnboarding.module.css";
import SlideUpWrapper from '../Transitions/SlideUpWrapper';
import pass from "./LoginForm.module.css"
import Loader from '../Loader';
import RightContent1 from './login_right';
import BtnLoader from '../BtnLoader';
import { UPDATE_PHONE } from '../../Utils/constant';
import { Delay } from '../../Utils/helper';
import API from "../../ApiConfig";
import cogoToast from 'cogo-toast-react-17-fix';
import { useNavigate } from 'react-router-dom';
const VerifyPhone = () => {
    const [loading, setLoading]=useState(false)
    const [phone, setPhone]=useState("")
    const navigate=useNavigate()

    const VerifyData=JSON.parse(localStorage.getItem("VerifyData"))    
    const VerifyPhone=async (e)=>{
        e.preventDefault()
        if(ValidatePhoneNo()){
            setLoading(true)
            await Delay()
            API.put(`${UPDATE_PHONE}${VerifyData.email}?phone_number=${phone}`)
            .then(res=>{
                setLoading(false)
                if(res.status==200){
                    let updatedVerifyData={...VerifyData,phone_no:phone}

                    localStorage.setItem("VerifyData",JSON.stringify(updatedVerifyData))
                    
                    cogoToast.success(res.data.message)  
                    navigate("/app/VerifyOtp")              
                }
            })
            .catch(err=>{
                setLoading(false)
                cogoToast.error(err.response.data.detail)
            })
        }
        }
     const ValidatePhoneNo=()=>{
                if(phone===""){
                    cogoToast.error("Please Enter Phone Number!!")
                    return false;
                  }
                  return true;
            }
  return (
    <SlideUpWrapper direction="slide-left">
        <div className={styles.userOnboarding}>
            <Loader isOpen={loading}/>
            <form className={pass.leftContent} onSubmit={VerifyPhone}>
                <div className={styles.progressForm}>
                    <div className={styles.progressForm1}>
                        <div className={pass.form}>                            
                            <div className={styles.form1}>
                                <img src="/passwordLogo.svg" alt="passwordLogo.svg" className={pass.passwordLogo}/>
                                <div className={styles.headingHelperText}>
                                    <h3 className={pass.Resetheading}>Verify Phone No</h3>
                                    <div className={pass.supportingText}>
                                        <p className={styles.weMessagedASixDigitCodeT}>
                                        <span className={pass.weMessagedA}>Verify your phone no. before changing password</span>
                                        </p>
                                        <div className={pass.inputdiv}>
                                            <div className={pass.Password}>
                                                <input type="text" className={pass.passInput}  id="name" name="name" value={phone} placeholder="Enter Phone" onChange={e=>setPhone(e.target.value)}/>
                                            </div>
                                        </div>
                                        <button type="submit" className={pass.forgotBtn} style={{width:"85%"}}>{loading?<BtnLoader label={"Verifying"}/>:"Verify Phone"}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={pass.copyright}>
                Copyright 2026 AuthBridge, All Rights Reserved.
            </div>
            </form>
      <RightContent1/>
        </div>
        </SlideUpWrapper>
  )
}

export default VerifyPhone